export const demo = {
  hero: {
    title: 'Request a Demo',
    subtitle: 'Discover how our solutions can transform your business. Complete the form and we will contact you to schedule your personalized demo.'
  },
  form: {
    title: 'Schedule Your Demo',
    priority: 'Demo Date Priority',
    priorityOptions: {
      asap: 'As soon as possible',
      thisWeek: 'This week',
      nextWeek: 'Next week',
      flexible: 'Flexible'
    },
    success: 'Thank you, we will contact you to schedule the demo.'
  }
};
